// frontend/src/pages/VendorDashboard.jsx - COMPLETE WITH GROUP ANALYTICS INTEGRATION
import React, { useState, useEffect } from 'react';
import { 
  TrendingUp, 
  Package, 
  Users, 
  DollarSign, 
  ShoppingBag,
  Clock,
  AlertCircle,
  CheckCircle,
  ArrowRight,
  Plus,
  Filter,
  Download,
  Bell,
  Briefcase,
  Star,
  Calendar,
  BarChart2,
  MessageSquare,
  Settings,
  ChevronRight,
  Eye,
  Edit,
  Trash2,
  Copy,
  RefreshCw,
  Upload,
  CreditCard,
  Banknote,
  Info,
  X,
  Target
} from 'lucide-react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useNotification } from '../context/NotificationContext';
import { useMessaging } from '../context/MessagingContext';
import BottomNav from '../components/common/BottomNav';
import NotificationBell from '../components/common/NotificationBell';
import AddProductModal from '../components/vendor/AddProductModal';
import Modal from '../components/common/Modal';
import MessageModal from '../components/messaging/MessageModal';
import { updateTerminology, getMemberMessage } from '../utils/memberLanguage';
import { formatTokenAmount } from '../utils/tokenEconomy';
import { formatDistanceToNow } from '../utils/dateUtils';
import { generateDemoGroups } from '../utils/groupData';
import ProductCard from '../components/vendor/ProductCard';
import { useQuery, useMutation } from '@apollo/client';
import { GET_VENDOR_PRODUCTS, GET_VENDOR_PURCHASES } from '../apollo/queries';  
import { UPDATE_PRODUCT, DELETE_PRODUCT } from '../apollo/mutations';
import EditProductModal from '../components/vendor/EditProductModal';



// REAL DATA SERVICE
import vendorDataService from '../services/VendorDataService';

// NEW: Import GroupAnalyticsModal
import GroupAnalyticsModal from '../components/vendor/GroupAnalyticsModal';


// Import vendor modals (placeholders for now)
const OrderConfirmationModal = ({ order, onConfirm, onClose }) => (
  <Modal isOpen={true} onClose={onClose} title="Confirm Order">
    <div className="space-y-4">
      <p>Confirm order for {order?.groupTitle}?</p>
      <div className="flex space-x-2">
        <button onClick={() => { onConfirm(order.id, {}); onClose(); }} className="px-4 py-2 bg-blue-600 text-white rounded">Confirm</button>
        <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Cancel</button>
      </div>
    </div>
  </Modal>
);

const FulfillmentModal = ({ order, onFulfill, onClose }) => (
  <Modal isOpen={true} onClose={onClose} title="Mark Fulfilled">
    <div className="space-y-4">
      <p>Mark order from {order?.groupTitle} as fulfilled?</p>
      <div className="flex space-x-2">
        <button onClick={() => { onFulfill(order.id, {}); onClose(); }} className="px-4 py-2 bg-green-600 text-white rounded">Fulfill</button>
        <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Cancel</button>
      </div>
    </div>
  </Modal>
);

const ProductDetailsModal = ({ product, onUpdate, onDelete, onClose }) => (
  <Modal isOpen={true} onClose={onClose} title="Product Details">
    <div className="space-y-4">
      <p>Product: {product?.name}</p>
      <div className="flex space-x-2">
        <button onClick={() => { onUpdate(product.id, {}); onClose(); }} className="px-4 py-2 bg-blue-600 text-white rounded">Update</button>
        <button onClick={() => { onDelete(product.id); onClose(); }} className="px-4 py-2 bg-red-600 text-white rounded">Delete</button>
        <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Close</button>
      </div>
    </div>
  </Modal>
);


const CSVUploadHandler = ({ onUpload, onClose }) => (
  <Modal isOpen={true} onClose={onClose} title="Upload CSV">
    <div className="space-y-4">
      <input type="file" accept=".csv" className="w-full border rounded px-3 py-2" />
      <div className="flex space-x-2">
        <button onClick={() => { onUpload([]); onClose(); }} className="px-4 py-2 bg-blue-600 text-white rounded">Upload</button>
        <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Cancel</button>
      </div>
    </div>
  </Modal>
);

const OrderDetailsModal = ({ order, onUpdate, onClose }) => (
  <Modal isOpen={true} onClose={onClose} title="Order Details">
    <div className="space-y-4">
      <p>Order: {order?.groupTitle}</p>
      <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Close</button>
    </div>
  </Modal>
);

const ApplicationsModal = ({ job, applications, onApprove, onReject, onClose }) => (
  <Modal isOpen={true} onClose={onClose} title="Job Applications">
    <div className="space-y-4">
      <p>Applications for: {job?.title}</p>
      <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Close</button>
    </div>
  </Modal>
);

const BusinessInfoModal = ({ vendor, onUpdate, onClose }) => (
  <Modal isOpen={true} onClose={onClose} title="Business Information">
    <div className="space-y-4">
      <input defaultValue={vendor?.businessName} placeholder="Business Name" className="w-full border rounded px-3 py-2" />
      <div className="flex space-x-2">
        <button onClick={() => { onUpdate({}); onClose(); }} className="px-4 py-2 bg-blue-600 text-white rounded">Update</button>
        <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Cancel</button>
      </div>
    </div>
  </Modal>
);

const PaymentMethodModal = ({ current, onUpdate, onClose }) => (
  <Modal isOpen={true} onClose={onClose} title="Payment Method">
    <div className="space-y-4">
      <p>Current: {current}</p>
      <div className="flex space-x-2">
        <button onClick={() => { onUpdate({ method: 'bank_transfer' }); onClose(); }} className="px-4 py-2 bg-blue-600 text-white rounded">Bank Transfer</button>
        <button onClick={() => { onUpdate({ method: 'check' }); onClose(); }} className="px-4 py-2 bg-gray-600 text-white rounded">Check</button>
        <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Cancel</button>
      </div>
    </div>
  </Modal>
);

const PaymentScheduleModal = ({ current, onUpdate, onClose }) => (
  <Modal isOpen={true} onClose={onClose} title="Payment Schedule">
    <div className="space-y-4">
      <p>Current: {current}</p>
      <div className="flex space-x-2">
        <button onClick={() => { onUpdate({ schedule: 'weekly' }); onClose(); }} className="px-4 py-2 bg-blue-600 text-white rounded">Weekly</button>
        <button onClick={() => { onUpdate({ schedule: 'monthly' }); onClose(); }} className="px-4 py-2 bg-gray-600 text-white rounded">Monthly</button>
        <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Cancel</button>
      </div>
    </div>
  </Modal>
);

const JobPostingForm = ({ isVendor, vendorId, vendorLocation, onClose, onPost }) => (
  <Modal isOpen={true} onClose={onClose} title="Post Job">
    <div className="space-y-4">
      <input placeholder="Job title" className="w-full border rounded px-3 py-2" />
      <textarea placeholder="Job description" className="w-full border rounded px-3 py-2"></textarea>
      <div className="flex space-x-2">
        <button onClick={() => { onPost({}); onClose(); }} className="px-4 py-2 bg-blue-600 text-white rounded">Post</button>
        <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">Cancel</button>
      </div>
    </div>
  </Modal>
);

// Vendor Payment Flow Documentation
const VENDOR_PAYMENT_FLOW = {
  overview: "Members pay → Platform fee (7.5%) → Logistics (7.5%) → Vendor (85%)",
  
  steps: [
    {
      name: "Member Payment",
      description: "Member pays full order amount at checkout",
      options: ["Tokens", "Credit Card", "Bank Transfer"],
      timing: "At checkout",
      icon: <CreditCard className="text-blue-600" size={20} />
    },
    {
      name: "Platform Fee Deduction",
      description: "7.5% automatically deducted for platform operations",
      calculation: "orderTotal × 0.075",
      timing: "Immediate",
      purpose: "Funds platform development, support, and token pool",
      icon: <DollarSign className="text-green-600" size={20} />
    },
    {
      name: "Logistics Allocation",
      description: "7.5% allocated for community logistics workers",
      calculation: "orderTotal × 0.075",
      timing: "Reserved at checkout",
      distribution: "Paid out as jobs are completed",
      icon: <Users className="text-purple-600" size={20} />
    },
    {
      name: "Vendor Settlement",
      description: "Vendor receives 85% of order total",
      calculation: "orderTotal × 0.85",
      timing: "Order completion + 3 days",
      frequency: "Weekly batch on Fridays",
      method: "Direct bank transfer or check",
      icon: <Banknote className="text-indigo-600" size={20} />
    }
  ],
  
  example: {
    orderTotal: 1000,
    platformFee: 75,
    logisticsFee: 75,
    vendorReceives: 850,
    settlementDate: "Friday after completion"
  },
  
  benefits: {
    vendor: "Predictable 85% revenue, no hidden fees",
    platform: "Sustainable operations without VC funding",
    logistics: "Creates jobs for community members",
    members: "Transparent pricing, supports local economy"
  }
};

const VendorDashboard = () => {
  const navigate = useNavigate();
  const { user, memberLogout, vendorLogout } = useAuth();
  const location = useLocation();
  const { addNotification } = useNotification();
  const { threads, unreadCount, getOrCreateThread } = useMessaging();
  
  const [loading, setLoading] = useState(true);
  const [vendorData, setVendorData] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  const [showProductModal, setShowProductModal] = useState(false);
  const [showJobModal, setShowJobModal] = useState(false);
  const [selectedTimeRange, setSelectedTimeRange] = useState('week');
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [messageRecipient, setMessageRecipient] = useState(null);
  
  // Modal states
  const [showOrderConfirmModal, setShowOrderConfirmModal] = useState(false);
  const [showFulfillmentModal, setShowFulfillmentModal] = useState(false);
  const [showProductDetailsModal, setShowProductDetailsModal] = useState(false);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [showCSVModal, setShowCSVModal] = useState(false);
  const [showOrderDetailsModal, setShowOrderDetailsModal] = useState(false);
  const [showApplicationsModal, setShowApplicationsModal] = useState(false);
  const [showBusinessModal, setShowBusinessModal] = useState(false);
  const [showPaymentMethodModal, setShowPaymentMethodModal] = useState(false);
  const [showPaymentScheduleModal, setShowPaymentScheduleModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  
  // NEW: Group Analytics Modal states
  const [showGroupAnalyticsModal, setShowGroupAnalyticsModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [availableGroups, setAvailableGroups] = useState([]);
  
  // REAL DATA STATE
  const [stats, setStats] = useState({});
  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [salesChartData, setSalesChartData] = useState([]);
  const { data: productsData, loading: productsLoading, refetch: refetchProducts } = useQuery(GET_VENDOR_PRODUCTS, {
  fetchPolicy: 'network-only'
  });

  const { data: purchasesData, loading: purchasesLoading, refetch: refetchPurchases } = useQuery(GET_VENDOR_PURCHASES, {
    fetchPolicy: 'network-only'
  });
  
  const [updateProductMutation] = useMutation(UPDATE_PRODUCT);
  const [deleteProductMutation] = useMutation(DELETE_PRODUCT);

  // Listen for vendor tab changes from Ava
  useEffect(() => {
    const handleTabChange = (event) => {
      setActiveTab(event.detail);
    };
    
    window.addEventListener('vendor-tab-change', handleTabChange);
    
    return () => {
      window.removeEventListener('vendor-tab-change', handleTabChange);
    };
  }, []);

  // Listen for add product modal from Ava
  useEffect(() => {
    const handleShowAddProduct = () => {
      setShowAddProductModal(true);
    };
    
    window.addEventListener('vendor-show-add-product', handleShowAddProduct);
    
    return () => {
      window.removeEventListener('vendor-show-add-product', handleShowAddProduct);
    };
  }, []);

  // Load products from GraphQL when data changes
  /*useEffect(() => {
    if (productsData && productsData.myProducts) {
      const transformedProducts = productsData.myProducts.map(product => ({
        ...product,
        totalSold: product.totalSold || 0,
        averageRating: product.averageRating || null,
        activeGroups: product.activeGroups || 0,
        totalRevenue: (product.totalSold || 0) * product.basePrice
      }));
      setProducts(transformedProducts);
    }
  }, [productsData]);*/

  useEffect(() => {
  if (productsData && productsData.myProducts) {
    // Just use the data as-is, don't transform
    setProducts(productsData.myProducts);
  }
}, [productsData]);

// Load orders from GraphQL
  useEffect(() => {
    if (purchasesData?.vendorPurchases) {
      const transformedOrders = purchasesData.vendorPurchases.map(purchase => ({
        id: purchase.id,
        status: purchase.status,
        totalAmount: purchase.totalAmount,
        createdAt: purchase.createdAt,
        products: purchase.products,
        logistics: purchase.logistics
      }));
      setOrders(transformedOrders);
    }
  }, [purchasesData]);

  // Load vendor data with REAL analytics
  useEffect(() => {
    const loadVendorData = async () => {
      setLoading(true);
      
      // Check if user is logged in as vendor
      const userType = localStorage.getItem('userType');
      const currentVendor = localStorage.getItem('currentVendor');
      
      if (userType !== 'vendor' || !currentVendor) {
        // Not a vendor, redirect to vendor login
        navigate('/vendor/login');
        return;
      }
      
      try {
        const vendor = JSON.parse(currentVendor);
        
        // Initialize vendor in data service if needed
        const initializedVendor = vendorDataService.initializeVendor(vendor);
        setVendorData(initializedVendor);
        
        // Load REAL analytics
        await loadRealAnalytics(vendor.id);
        
        // NEW: Load available groups for analytics
        loadAvailableGroups();
        
      } catch (e) {
        console.error('Error loading vendor data:', e);
        navigate('/vendor/login');
        return;
      } finally {
        setLoading(false);
      }
    };
    
    loadVendorData();
  }, [navigate]);

  // NEW: Load available groups for analytics modal access
  const loadAvailableGroups = () => {
    try {
      const allGroups = generateDemoGroups();
      // Filter to groups that might be relevant to vendors
      const relevantGroups = allGroups.filter(group => !group.isCompleted);
      setAvailableGroups(relevantGroups);
    } catch (error) {
      console.error('Error loading groups:', error);
    }
  };

  // Reload analytics when time range changes
  useEffect(() => {
    if (vendorData?.id) {
      loadRealAnalytics(vendorData.id);
    }
  }, [selectedTimeRange, vendorData]);

  useEffect(() => {
    // Handle navigation state for tab switching
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  /**
   * Load REAL analytics from VendorDataService
   */
  const loadRealAnalytics = async (vendorId) => {
    try {
      // Get real analytics
      const realStats = vendorDataService.calculateVendorAnalytics(vendorId, selectedTimeRange);
      setStats(realStats);
      
      // Get real orders
      // const realOrders = vendorDataService.getVendorOrders(vendorId);
      // setOrders(realOrders);
      
      // Get real products
      //const realProducts = vendorDataService.getVendorProducts(vendorId);
      //setProducts(realProducts);
      
      // Get real sales chart data
      const chartData = vendorDataService.generateSalesChartData(vendorId, selectedTimeRange);
      setSalesChartData(chartData);
      
      // Load jobs (placeholder for now)
      setJobs([]);
      
    } catch (error) {
      console.error('Error loading real analytics:', error);
      addNotification({
        type: 'error',
        title: 'Data Loading Error',
        message: 'Failed to load vendor analytics',
        showToast: true
      });
    }
  };

  // Calculate metrics
  const getOrderStatusColor = (status) => {
    switch (status) {
      case 'pending':
        return 'text-yellow-600 bg-yellow-50';
      case 'confirmed':
        return 'text-blue-600 bg-blue-50';
      case 'fulfilled':
        return 'text-green-600 bg-green-50';
      case 'cancelled':
        return 'text-red-600 bg-red-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };

  const formatDeadline = (date) => {
    const now = new Date();
    const targetDate = new Date(date);
    const diff = targetDate - now;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(hours / 24);
    
    if (hours < 24) {
      return `${hours} hours`;
    } else {
      return `${days} days`;
    }
  };

  // Handler functions with REAL data operations
  const handleStartBulkOrder = () => {
    // Navigate to REAL bulk order page
    navigate('/vendor/bulk-order');
  };

  const handleDiscoverGroups = () => {
    navigate('/vendor/groups');
  };

  // NEW: Handle group analytics modal
  const handleViewGroupAnalytics = (groupId) => {
    const group = availableGroups.find(g => g.id === groupId);
    if (group) {
      setSelectedGroup(group);
      setShowGroupAnalyticsModal(true);
    }
  };

  const handleOpenMessage = (recipientId, recipientName, recipientType, orderRef = null) => {
    setMessageRecipient({ recipientId, recipientName, recipientType, orderRef });
    setShowMessageModal(true);
  };

  const confirmOrder = async (orderId, data) => {
    try {
      // Update order status using REAL data service
      const updatedOrder = vendorDataService.updateOrderStatus(
        vendorData.id, 
        orderId, 
        'confirmed', 
        {
          confirmedAt: data.confirmedAt || new Date().toISOString(),
          notes: data.notes
        }
      );
      
      // Reload orders
      const realOrders = vendorDataService.getVendorOrders(vendorData.id);
      setOrders(realOrders);
      
      // Reload analytics
      await loadRealAnalytics(vendorData.id);
      
      addNotification({
        type: 'success',
        title: 'Order Confirmed',
        message: 'Order has been confirmed and members have been notified.',
        showToast: true
      });
    } catch (error) {
      addNotification({
        type: 'error',
        title: 'Confirmation Error',
        message: error.message,
        showToast: true
      });
    }
  };

  const fulfillOrder = async (orderId, data) => {
    try {
      // Update order status using REAL data service
      const updatedOrder = vendorDataService.updateOrderStatus(
        vendorData.id, 
        orderId, 
        'fulfilled', 
        {
          fulfilledAt: data.fulfilledAt || new Date().toISOString(),
          actualUnits: data.actualUnits,
          fulfillmentNotes: data.notes
        }
      );
      
      // Reload orders
      const realOrders = vendorDataService.getVendorOrders(vendorData.id);
      setOrders(realOrders);
      
      // Reload analytics
      await loadRealAnalytics(vendorData.id);
      
      addNotification({
        type: 'success',
        title: 'Order Fulfilled',
        message: 'Order marked as fulfilled. Payment will be processed on the next scheduled date.',
        showToast: true
      });
    } catch (error) {
      addNotification({
        type: 'error',
        title: 'Fulfillment Error',
        message: error.message,
        showToast: true
      });
    }
  };

  const updateProduct = async (productId, data) => {
    try {
      await updateProductMutation({
        variables: {
          id: productId,
          input: data
        }
      });
    
      // Refetch to get updated data
      await refetchProducts();
    
      addNotification({
        type: 'success',
        title: 'Product Updated',
        message: 'Product information has been updated.',
        showToast: true
      });
    } catch (error) {
      addNotification({
        type: 'error',
        title: 'Update Error',
        message: error.message,
        showToast: true
      });
    }
  };
  const deleteProduct = async (productId) => {
    try {
      await deleteProductMutation({
        variables: { id: productId }
      });
      // Refetch to update list
      await refetchProducts();
      
      addNotification({
        type: 'success',
        title: 'Product Deleted',
        message: 'Product has been removed from your catalog.',
        showToast: true
      });
    } catch (error) {
      addNotification({
        type: 'error',
        title: 'Delete Error',
        message: error.message,
        showToast: true
      });
    }
  };

  const addProduct = async (productData) => {
    try {
      // The AddProductModal already creates the product via GraphQL
      // We just need to refresh the list
      // Store current product count before refetch
      const previousCount = products.length;
      
      await refetchProducts();

      // Safety check - if we had products but now have none, something went wrong
      if (previousCount > 0 && products.length === 0) {
        // Force a harder refresh
        window.location.reload();
        return;
      }
    
      addNotification({
        type: 'success',
        title: 'Product Added',
        message: 'New product has been added to your catalog.',
        showToast: true
      });
    } catch (error) {
      // On error, force refresh to ensure products show
      console.error('Refetch failed:', error);
      window.location.reload();


      addNotification({
        type: 'error',
        title: 'Add Product Error',
        message: 'Product created but list refresh failed. Reloading...',
        showToast: true
      });
    }
  };

  const uploadProducts = async (productsData) => {
    try {
      // Add multiple products
      for (const productData of productsData) {
        vendorDataService.addProduct(vendorData.id, productData);
      }
      
      // Reload products
      //const realProducts = vendorDataService.getVendorProducts(vendorData.id);
      //setProducts(realProducts);
      
      // Reload analytics
      await loadRealAnalytics(vendorData.id);
      
      addNotification({
        type: 'success',
        title: 'Products Imported',
        message: `${productsData.length} products have been imported successfully.`,
        showToast: true
      });
    } catch (error) {
      addNotification({
        type: 'error',
        title: 'Import Error',
        message: error.message,
        showToast: true
      });
    }
  };

  const updateOrderStatus = async (orderId, updates) => {
    try {
      vendorDataService.updateOrderStatus(vendorData.id, orderId, updates.status, updates);
      
      // Reload orders and analytics
      refetchPurchases();
      await loadRealAnalytics(vendorData.id);
    } catch (error) {
      console.error('Error updating order status:', error);
    }
  };

  const postVendorJob = async (jobData) => {
    const newJob = {
      ...jobData,
      id: `vendor_job_${Date.now()}`,
      vendorId: vendorData.id,
      postedBy: vendorData.businessName,
      postedDate: new Date().toISOString(),
      status: 'open',
      applicants: 0,
      views: 0
    };
    
    setJobs(prev => [...prev, newJob]);
    
    addNotification({
      type: 'success',
      title: 'Job Posted',
      message: 'Your logistics job has been posted successfully.',
      showToast: true
    });
  };

  const approveApplication = async (jobId, applicationId) => {
    // Update job status
    setJobs(prev => prev.map(job => 
      job.id === jobId ? { ...job, status: 'filled' } : job
    ));
    
    addNotification({
      type: 'success',
      title: 'Application Approved',
      message: 'The member has been notified and can start the job.',
      showToast: true
    });
  };

  const rejectApplication = async (jobId, applicationId, reason) => {
    addNotification({
      type: 'info',
      title: 'Application Rejected',
      message: 'The applicant has been notified.',
      showToast: true
    });
  };

  const updateBusinessInfo = async (data) => {
    const updatedVendor = { ...vendorData, ...data };
    setVendorData(updatedVendor);
    localStorage.setItem('currentVendor', JSON.stringify(updatedVendor));
    vendorDataService.saveVendorData(vendorData.id, updatedVendor);
    
    addNotification({
      type: 'success',
      title: 'Business Information Updated',
      message: 'Your business information has been saved.',
      showToast: true
    });
  };

  const updatePaymentMethod = async (data) => {
    const updatedVendor = { ...vendorData, paymentMethod: data.method };
    setVendorData(updatedVendor);
    localStorage.setItem('currentVendor', JSON.stringify(updatedVendor));
    vendorDataService.saveVendorData(vendorData.id, updatedVendor);
    
    addNotification({
      type: 'success',
      title: 'Payment Method Updated',
      message: 'Your payment method has been updated.',
      showToast: true
    });
  };

  const updatePaymentSchedule = async (data) => {
    const updatedVendor = { ...vendorData, paymentSchedule: data.schedule };
    setVendorData(updatedVendor);
    localStorage.setItem('currentVendor', JSON.stringify(updatedVendor));
    vendorDataService.saveVendorData(vendorData.id, updatedVendor);
    
    addNotification({
      type: 'success',
      title: 'Payment Schedule Updated',
      message: 'Your payment schedule has been updated.',
      showToast: true
    });
  };

  const handleConfirmOrder = (orderId) => {
    const order = orders.find(o => o.id === orderId);
    setSelectedOrder(order);
    setShowOrderConfirmModal(true);
  };

  const handleMarkFulfilled = (orderId) => {
    const order = orders.find(o => o.id === orderId);
    setSelectedOrder(order);
    setShowFulfillmentModal(true);
  };

  const handleQuickJobPost = () => {
    setShowJobModal(true);
  };

  const handleAddProduct = () => {
    setShowAddProductModal(true);
  };

  const handleViewAllOrders = () => {
    setActiveTab('orders');
    // Optionally filter orders
    setTimeout(() => {
      const filterSelect = document.querySelector('.order-filter-select');
      if (filterSelect) {
        filterSelect.value = 'active';
        filterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 100);
  };

  const handleExportData = () => {
    // Export REAL data
    const exportData = {
      vendor: vendorData,
      orders: orders,
      products: products,
      analytics: stats,
      exportedAt: new Date().toISOString()
    };
    
    const dataStr = JSON.stringify(exportData, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `vendor_data_${vendorData.businessName}_${new Date().toISOString().split('T')[0]}.json`;
    link.click();
    
    addNotification({
      type: 'success',
      title: 'Data Exported',
      message: 'Your vendor data has been exported successfully.',
      showToast: true
    });
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <RefreshCw className="animate-spin h-8 w-8 text-blue-600 mx-auto mb-4" />
          <p className="text-gray-600">Loading your real vendor analytics...</p>
        </div>
      </div>
    );
  }

  const renderOverviewTab = () => (
    <div className="space-y-6">
      {/* Quick Stats - REAL DATA */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 overview-stats">
        <div className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center justify-between mb-2">
            <DollarSign className="text-green-600" size={20} />
            <span className={`text-xs font-medium px-2 py-1 rounded-full ${
              stats.weeklyGrowth > 0 ? 'bg-green-100 text-green-700' : 
              stats.weeklyGrowth < 0 ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-700'
            }`}>
              {stats.weeklyGrowth > 0 ? '+' : ''}{stats.weeklyGrowth || 0}%
            </span>
          </div>
          <div className="text-2xl font-bold">${(stats.totalSales || 0).toLocaleString()}</div>
          <p className="text-sm text-gray-600">{stats.periodLabel || 'Total Sales'}</p>
        </div>
        
        <div className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center justify-between mb-2">
            <ShoppingBag className="text-blue-600" size={20} />
            <span className="text-xs font-medium text-yellow-600">
              {stats.pendingOrders || 0} pending
            </span>
          </div>
          <div className="text-2xl font-bold">{stats.activeOrders || 0}</div>
          <p className="text-sm text-gray-600">Active Orders</p>
        </div>
        
        <div className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center justify-between mb-2">
            <Users className="text-purple-600" size={20} />
            <TrendingUp className="text-gray-400" size={16} />
          </div>
          <div className="text-2xl font-bold">{stats.totalMembers || 0}</div>
          <p className="text-sm text-gray-600">{updateTerminology('Members Served')}</p>
        </div>
        
        <div className="bg-white rounded-lg shadow p-4">
          <div className="flex items-center justify-between mb-2">
            <Star className="text-yellow-500" size={20} />
            <span className="text-xs text-gray-500">{stats.completionRate || 100}%</span>
          </div>
          <div className="text-2xl font-bold">{stats.averageRating || 'N/A'}</div>
          <p className="text-sm text-gray-600">Average Rating</p>
        </div>
      </div>

      {/* Active Orders - REAL DATA with Analytics Integration */}
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b flex items-center justify-between">
          <h3 className="font-semibold">Active Orders</h3>
          <button 
            onClick={handleViewAllOrders}
            className="text-blue-600 text-sm hover:underline"
          >
            View All
          </button>
        </div>
        <div className="divide-y">
          {orders.filter(o => ['pending', 'confirmed'].includes(o.status)).slice(0, 3).map(order => (
            <div key={order.id} className="p-4">
              <div className="flex items-center justify-between mb-2">
                <div>
                  <h4 className="font-medium flex items-center">
                    {order.groupTitle}
                    {/* NEW: Group Analytics Button */}
                    <button
                      onClick={() => handleViewGroupAnalytics(order.groupId)}
                      className="ml-2 p-1 hover:bg-gray-100 rounded text-blue-600"
                      title="View group analytics"
                    >
                      <BarChart2 size={14} />
                    </button>
                  </h4>
                  <p className="text-sm text-gray-600">
                    {order.memberCount} {updateTerminology('members')} • {order.quantity} units
                  </p>
                </div>
                <div className="text-right">
                  <div className="font-semibold">${order.totalValue}</div>
                  <span className={`inline-flex px-2 py-1 text-xs rounded-full ${getOrderStatusColor(order.status)}`}>
                    {order.status}
                  </span>
                </div>
              </div>
              
              <div className="flex items-center justify-between mt-3">
                <div className="flex items-center text-sm text-gray-600">
                  <Clock size={14} className="mr-1" />
                  <span>Due in {formatDeadline(order.deadline)}</span>
                </div>
                
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => handleOpenMessage(
                      `admin_${order.groupTitle.toLowerCase().replace(/\s+/g, '_')}`,
                      `${order.groupTitle} Admin`,
                      'admin',
                      order.id
                    )}
                    className="p-1 hover:bg-gray-100 rounded text-blue-600"
                    title="Message group admin"
                  >
                    <MessageSquare size={16} />
                  </button>
                  
                  {order.status === 'pending' && (
                    <button
                      onClick={() => handleConfirmOrder(order.id)}
                      className="px-3 py-1 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700"
                    >
                      Confirm Order
                    </button>
                  )}
                  
                  {order.status === 'confirmed' && (
                    <button
                      onClick={() => handleMarkFulfilled(order.id)}
                      className="px-3 py-1 bg-green-600 text-white text-sm rounded-lg hover:bg-green-700"
                    >
                      Mark Fulfilled
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
          
          {orders.filter(o => ['pending', 'confirmed'].includes(o.status)).length === 0 && (
            <div className="p-8 text-center text-gray-500">
              <ShoppingBag size={48} className="mx-auto mb-4 opacity-20" />
              <h3 className="font-medium text-gray-900 mb-2">No Active Orders</h3>
              <p className="text-sm">When members place orders, they'll appear here.</p>
              <button
                onClick={handleAddProduct}
                className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                {products.length === 0 ? 'Add Your First Product' : products.length < 10 ? 'Add More Products' : 'Add Product'}
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <button
          onClick={handleAddProduct}
          className="bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow text-left"
        >
          <Package className="text-blue-600 mb-2" size={24} />
          <h4 className="font-medium">Add Product</h4>
          <p className="text-sm text-gray-600">List a new product</p>
        </button>
        
        <button
          onClick={handleQuickJobPost}
          className="bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow text-left"
        >
          <Briefcase className="text-green-600 mb-2" size={24} />
          <h4 className="font-medium">Post Job</h4>
          <p className="text-sm text-gray-600">Find helpers</p>
        </button>
        
        <button
          onClick={() => setActiveTab('analytics')}
          className="bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow text-left"
        >
          <BarChart2 className="text-purple-600 mb-2" size={24} />
          <h4 className="font-medium">View Analytics</h4>
          <p className="text-sm text-gray-600">Track performance</p>
        </button>
        
        <button
          onClick={handleDiscoverGroups}
          className="bg-white rounded-lg shadow p-4 hover:shadow-md transition-shadow text-left"
        >
          <Target className="text-orange-600 mb-2" size={24} />
          <h4 className="font-medium">Discover Groups</h4>
          <p className="text-sm text-gray-600">Find groups for your products</p>
        </button>
      </div>

      {/* Recent Activity */}
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b">
          <h3 className="font-semibold">Recent Activity</h3>
        </div>
        <div className="p-4 space-y-3">
          {orders.slice(0, 3).map(order => (
            <div key={order.id} className="flex items-center justify-between text-sm">
              <div className="flex items-center">
                <div className={`w-2 h-2 ${order.status === 'pending' ? 'bg-yellow-500' : 'bg-green-500'} rounded-full mr-3`}></div>
                <span>Order from {order.groupTitle}: ${order.totalValue}</span>
              </div>
              <span className="text-gray-500">{formatDistanceToNow(new Date(order.createdAt))}</span>
            </div>
          ))}
          
          {orders.length === 0 && (
            <div className="text-center text-gray-500 py-4">
              <p>No recent activity. Add products to start receiving orders!</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderAnalyticsTab = () => (
    <div className="space-y-6">
      {/* Analytics Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold">Analytics</h2>
          <p className="text-gray-600">Track your business performance with REAL data</p>
        </div>
        <div className="flex space-x-2">
          <select 
            value={selectedTimeRange}
            onChange={(e) => setSelectedTimeRange(e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
          >
            <option value="week">Last 7 days</option>
            <option value="month">Last 30 days</option>
            <option value="quarter">Last 3 months</option>
            <option value="year">Last year</option>
          </select>
          <button 
            onClick={handleExportData}
            className="px-3 py-2 border border-gray-300 rounded-lg text-sm hover:bg-gray-50 flex items-center"
          >
            <Download size={16} className="mr-2" />
            Export
          </button>
        </div>
      </div>

      {/* Performance Metrics - REAL DATA */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="font-semibold mb-4">Sales Performance</h3>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600">Total Revenue</span>
              <span className="font-medium">${(stats.totalSales || 0).toLocaleString()}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Average Order</span>
              <span className="font-medium">${stats.averageOrderValue || 0}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Growth Rate</span>
              <span className={`font-medium ${(stats.weeklyGrowth || 0) > 0 ? 'text-green-600' : 'text-red-600'}`}>
                {(stats.weeklyGrowth || 0) > 0 ? '+' : ''}{stats.weeklyGrowth || 0}%
              </span>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="font-semibold mb-4">{updateTerminology('Member')} Engagement</h3>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600">Total {updateTerminology('Members')}</span>
              <span className="font-medium">{stats.totalMembers || 0}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Repeat Rate</span>
              <span className="font-medium">Coming Soon</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Avg Rating</span>
              <span className="font-medium flex items-center">
                {stats.averageRating || 'N/A'}
                {stats.averageRating && <Star size={14} className="text-yellow-500 fill-current ml-1" />}
              </span>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="font-semibold mb-4">Operational Metrics</h3>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600">Completion Rate</span>
              <span className="font-medium">{stats.completionRate || 100}%</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Total Products</span>
              <span className="font-medium">{stats.totalProducts || 0}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Active Orders</span>
              <span className="font-medium">{stats.activeOrders || 0}</span>
            </div>
          </div>
        </div>
      </div>

      {/* REAL Sales Chart */}
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="font-semibold mb-4">Sales Trend - REAL DATA</h3>
        <div className="h-64">
          {salesChartData.length > 0 ? (
            <div className="flex items-end justify-between gap-2 h-full">
              {salesChartData.map((day, index) => {
                const maxSales = Math.max(...salesChartData.map(d => d.sales), 1);
                const height = (day.sales / maxSales) * 100;
                
                return (
                  <div key={index} className="flex-1 flex flex-col items-center justify-end">
                    <div className="text-xs font-medium mb-1">
                      ${Math.round(day.sales)}
                    </div>
                    <div 
                      className="w-full bg-blue-500 rounded-t transition-all duration-300 hover:bg-blue-600"
                      style={{ height: `${height}%`, minHeight: day.sales > 0 ? '20px' : '2px' }}
                      title={`${day.day}: ${day.sales} (${day.orders} orders)`}
                    />
                    <div className="text-xs text-gray-600 mt-2">{day.day}</div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="h-full flex items-center justify-center text-gray-500">
              <div className="text-center">
                <BarChart2 size={48} className="mx-auto mb-4 opacity-20" />
                <h4 className="font-medium text-gray-900 mb-2">No Sales Data Yet</h4>
                <p className="text-sm">Add products and start receiving orders to see your sales trend.</p>
              </div>
            </div>
          )}
        </div>
        <div className="mt-4 flex justify-between text-sm">
          <span className="text-gray-600">{stats.periodLabel}:</span>
          <span className="font-semibold">${(stats.totalSales || 0).toLocaleString()}</span>
        </div>
        <div className="flex justify-between text-sm mt-1">
          <span className="text-gray-600">Growth:</span>
          <span className={`font-semibold ${
            (stats.weeklyGrowth || 0) > 0 ? 'text-green-600' : 'text-red-600'
          }`}>
            {(stats.weeklyGrowth || 0) > 0 ? '+' : ''}{stats.weeklyGrowth || 0}%
          </span>
        </div>
      </div>

      {/* Top Products - REAL DATA */}
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="font-semibold mb-4">Top Performing Products</h3>
        {products.length > 0 ? (
          <div className="space-y-3">
            {vendorDataService.getTopProducts(vendorData.id, 5).map((product, index) => (
              <div key={product.id} className="flex items-center justify-between">
                <div className="flex items-center">
                  <span className="w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-sm font-medium mr-3">
                    {index + 1}
                  </span>
                  <div>
                    <p className="font-medium">{product.name}</p>
                    <p className="text-sm text-gray-600">{product.totalSold} units sold</p>
                  </div>
                </div>
                <span className="font-medium">${(product.totalRevenue || 0).toFixed(2)}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-500 py-8">
            <Package size={48} className="mx-auto mb-4 opacity-20" />
            <h4 className="font-medium text-gray-900 mb-2">No Products Yet</h4>
            <p className="text-sm">Add your first product to start tracking performance.</p>
            <button
              onClick={handleAddProduct}
              className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Add Product
            </button>
          </div>
        )}
      </div>
    </div>
  );

  const renderProductsTab = () => (
    <div className="space-y-6">
      {/* Product Statistics Dashboard */}
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {/* Total Products */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Total Products</p>
            <p className="text-3xl font-bold text-blue-600">{products.length}</p>
          </div>
          <Package className="text-blue-300" size={32} />
        </div>
      </div>

      {/* Active Products */}
      <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Active</p>
            <p className="text-3xl font-bold text-green-600">
              {products.filter(p => p.available !== false).length}
            </p>
          </div>
          <CheckCircle className="text-green-300" size={32} />
        </div>
      </div>

      {/* Pending Approval */}
      <div className="bg-gradient-to-r from-yellow-50 to-amber-50 border border-yellow-200 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">Pending Approval</p>
            <p className="text-3xl font-bold text-yellow-600">
              {products.filter(p => p.approvalStatus === 'pending').length}
            </p>
          </div>
          <Clock className="text-yellow-300" size={32} />
        </div>
      </div>

      {/* Products with Tiers */}
      <div className="bg-gradient-to-r from-purple-50 to-pink-50 border border-purple-200 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600">With Bulk Pricing</p>
            <p className="text-3xl font-bold text-purple-600">
              {products.filter(p => p.priceTiers && p.priceTiers.length > 0).length}
            </p>
          </div>
          <Users className="text-purple-300" size={32} />
        </div>
      </div>
    </div>


      {/* Products Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold">Products</h2>
          <p className="text-gray-600">Manage your product listings</p>
        </div>
        <button
        
          onClick={() => {
            console.log('🔵 Add Product button clicked!');
            setShowAddProductModal(true);
            console.log('🔵 showAddProductModal set to true');
          }}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 flex items-center add-product-button"
        >
          <Plus size={18} className="mr-2" />
          Add Product
        </button>
      </div>

      {/* Products Grid - REAL DATA */}
      {products.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {products.map(product => (
            <ProductCard
              key={product.id}
              product={product}
              onEdit={(product) => {
                setSelectedProduct(product);
                setShowProductDetailsModal(true);
              }}
              onView={(product) => {
                setSelectedProduct(product);
                setShowProductDetailsModal(true);
              }}
              onDelete={async (product) => {
                if (window.confirm(`Are you sure you want to delete ${product.name}?`)) {
                  await deleteProduct(product.id);  // Call the REAL delete function
                }
              }}
            />
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow p-12 text-center">
          <Package size={64} className="mx-auto mb-6 text-gray-300" />
          <h3 className="text-xl font-semibold text-gray-900 mb-4">No Products Yet</h3>
          <p className="text-gray-600 mb-8 max-w-md mx-auto">
            Start by adding your first product. It only takes a few minutes to get your products in front of community groups!
          </p>
          <div className="space-y-3">
            <button
              onClick={() => setShowAddProductModal(true)}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 inline-flex items-center"
            >
              <Plus size={20} className="mr-2" />
              {products.length === 0 ? 'Add Your First Product' : products.length < 10 ? 'Add More Products' : 'Add Product'}
            </button>
            <p className="text-sm text-gray-500">
              {products.length === 0
                ? 'Quick setup • No commitment • Start receiving orders today'
                : `You have ${products.length} products • Keep growing your catalog`}
            </p>
          </div>
        </div>
      )}

      {/* Bulk Import */}
      <div className="bg-blue-50 rounded-lg p-6 border border-blue-200">
        <div className="flex items-start">
          <Upload className="text-blue-600 mr-3 mt-0.5" size={24} />
          <div className="flex-1">
            <h3 className="font-semibold text-blue-900 mb-2">Bulk Import Products</h3>
            <p className="text-sm text-blue-800 mb-3">
              Have many products? Upload a CSV file to add them all at once. Perfect for getting started quickly!
            </p>
            <button 
              onClick={() => setShowCSVModal(true)}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700"
            >
              Upload CSV
            </button> 
          </div>
        </div>
      </div>
    </div>
  );

  const renderOrdersTab = () => (
    <div className="space-y-6">
      {/* Orders Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold">Orders</h2>
          <p className="text-gray-600">Manage your group orders - REAL DATA</p>
        </div>
        <div className="flex space-x-2">
          <select className="px-3 py-2 border border-gray-300 rounded-lg text-sm order-filter-select">
            <option>All Orders</option>
            <option>Pending</option>
            <option>Confirmed</option>
            <option>Fulfilled</option>
          </select>
          <button className="px-3 py-2 border border-gray-300 rounded-lg text-sm hover:bg-gray-50">
            <Filter size={16} />
          </button>
        </div>
      </div>

      {/* Orders List - REAL DATA */}
      <div className="bg-white rounded-lg shadow">
        {orders.length > 0 ? (
          <div className="divide-y">
            {orders.map(order => (
              <div key={order.id} className="p-4 hover:bg-gray-50">
                <div className="flex items-center justify-between mb-3">
                  <div>
                    <h3 className="font-semibold flex items-center">
                      {order.groupTitle}
                      {/* Group Analytics Access */}
                      <button
                        onClick={() => handleViewGroupAnalytics(order.groupId)}
                        className="ml-2 p-1 hover:bg-gray-100 rounded text-blue-600"
                        title="View group analytics"
                      >
                        <BarChart2 size={14} />
                      </button>
                    </h3>
                    <p className="text-sm text-gray-600">
                      Order #{order.id.split('_')[1]} • {order.productName}
                    </p>
                  </div>
                  <span className={`px-3 py-1 text-sm rounded-full font-medium ${getOrderStatusColor(order.status)}`}>
                    {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                  </span>
                </div>
                
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-3 text-sm">
                  <div>
                    <span className="text-gray-600">{updateTerminology('Members')}:</span>
                    <p className="font-medium">{order.memberCount}</p>
                  </div>
                  <div>
                    <span className="text-gray-600">Quantity:</span>
                    <p className="font-medium">{order.quantity}</p>
                  </div>
                  <div>
                    <span className="text-gray-600">Total Value:</span>
                    <p className="font-medium">${order.totalValue}</p>
                  </div>
                  <div>
                    <span className="text-gray-600">
                      {order.status === 'fulfilled' ? 'Completed:' : 'Deadline:'}
                    </span>
                    <p className="font-medium">
                      {order.status === 'fulfilled' 
                        ? new Date(order.fulfilledAt || order.createdAt).toLocaleDateString()
                        : formatDeadline(order.deadline)
                      }
                    </p>
                  </div>
                </div>
                
                {order.pickupLocation && (
                  <div className="text-sm text-gray-600 mb-3">
                    <span className="font-medium">Pickup:</span> {order.pickupLocation}
                  </div>
                )}
                
                <div className="flex justify-end space-x-2">
                  <button 
                    onClick={() => handleOpenMessage(
                      `admin_${order.groupTitle.toLowerCase().replace(/\s+/g, '_')}`,
                      `${order.groupTitle} Admin`,
                      'admin',
                      order.id
                    )}
                    className="px-3 py-1 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 flex items-center"
                  >
                    <MessageSquare size={14} className="mr-1" />
                    Message
                  </button>
                  <button 
                    onClick={() => {
                      setSelectedOrder(order);
                      setShowOrderDetailsModal(true);
                    }}
                    className="px-3 py-1 text-sm border border-gray-300 rounded-lg hover:bg-gray-50"
                  >
                    View Details
                  </button>
                  {order.status === 'pending' && (
                    <button
                      onClick={() => handleConfirmOrder(order.id)}
                      className="px-3 py-1 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                    >
                      Confirm Order
                    </button>
                  )}
                  {order.status === 'confirmed' && (
                    <button
                      onClick={() => handleMarkFulfilled(order.id)}
                      className="px-3 py-1 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700"
                    >
                      Mark Fulfilled
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="p-12 text-center">
            <ShoppingBag size={64} className="mx-auto mb-6 text-gray-300" />
            <h3 className="text-xl font-semibold text-gray-900 mb-4">No Orders Yet</h3>
            <p className="text-gray-600 mb-8 max-w-md mx-auto">
              Once you add products and groups start ordering, your orders will appear here.
            </p>
            <button
              onClick={handleAddProduct}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700"
            >
              Add Products to Start Receiving Orders
            </button>
          </div>
        )}
      </div>
    </div>
  );

  const renderJobsTab = () => (
    <div className="space-y-6">
      {/* Jobs Header */}
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-xl font-semibold">Logistics Jobs</h2>
          <p className="text-gray-600">Find help from skilled {updateTerminology('members')}</p>
        </div>
        <button
          onClick={handleQuickJobPost}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 flex items-center"
        >
          <Plus size={18} className="mr-2" />
          Post Job
        </button>
      </div>

      {/* Token Budget */}
      <div className="bg-blue-50 rounded-lg p-4 border border-blue-200">
        <div className="flex items-center justify-between mb-2">
          <h3 className="font-medium text-blue-900">Your Token Budget</h3>
          <span className="text-sm text-blue-700">This Month</span>
        </div>
        <div className="relative bg-blue-100 rounded-full h-3 mb-2">
          <div 
            className="absolute top-0 left-0 h-full bg-blue-600 rounded-full"
            style={{ width: '45%' }}
          />
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-blue-700">Used: {formatTokenAmount(stats.tokensEarned || 0)}</span>
          <span className="text-blue-900 font-medium">Remaining: {formatTokenAmount(1000 - (stats.tokensEarned || 0))}</span>
        </div>
      </div>

      {/* Jobs List */}
      <div className="space-y-4">
        {jobs.length > 0 ? jobs.map(job => (
          <div key={job.id} className="bg-white rounded-lg shadow p-4">
            <div className="flex items-center justify-between mb-3">
              <div>
                <h3 className="font-semibold">{job.title}</h3>
                <p className="text-sm text-gray-600">{job.schedule}</p>
              </div>
              <div className="text-right">
                <div className="font-semibold text-green-600">
                  {job.tokenReward} tokens
                </div>
                <span className={`text-xs px-2 py-1 rounded-full ${
                  job.status === 'open' 
                    ? 'bg-green-100 text-green-700' 
                    : 'bg-gray-100 text-gray-700'
                }`}>
                  {job.status}
                </span>
              </div>
            </div>
            
            <div className="mb-3">
              <p className="text-sm text-gray-600 mb-2">Required Skills:</p>
              <div className="flex flex-wrap gap-2">
                {job.skillsRequired?.map((skill, index) => (
                  <span key={index} className="text-xs px-2 py-1 bg-gray-100 rounded-full">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
            
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">
                {job.applicants} applicants
              </span>
              <button 
                onClick={() => {
                  setSelectedJob(job);
                  setShowApplicationsModal(true);
                }}
                className="text-blue-600 text-sm hover:underline"
              >
                View Applications →
              </button>
            </div>
          </div>
        )) : (
          <div className="bg-white rounded-lg shadow p-12 text-center">
            <Briefcase size={64} className="mx-auto mb-6 text-gray-300" />
            <h3 className="text-xl font-semibold text-gray-900 mb-4">No Jobs Posted Yet</h3>
            <p className="text-gray-600 mb-8 max-w-md mx-auto">
              Need help with deliveries, setup, or coordination? Post jobs to find skilled community members.
            </p>
            <button
              onClick={handleQuickJobPost}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700"
            >
              Post Your First Job
            </button>
          </div>
        )}
      </div>

      {/* Jobs Benefits */}
      <div className="bg-gray-50 rounded-lg p-6">
        <h3 className="font-semibold mb-3">Why Post Jobs on UniLedge?</h3>
        <div className="space-y-2 text-sm text-gray-600">
          <div className="flex items-start">
            <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5" />
            <span>Access verified, skilled {updateTerminology('members')} in your community</span>
          </div>
          <div className="flex items-start">
            <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5" />
            <span>Pay only for work completed - no hourly commitments</span>
          </div>
          <div className="flex items-start">
            <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5" />
            <span>Build relationships with reliable local workers</span>
          </div>
          <div className="flex items-start">
            <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5" />
            <span>Automatic trust score filtering ensures quality</span>
          </div>
        </div>
      </div>
    </div>
  );

  const renderSettingsTab = () => (
    <div className="space-y-6">
      {/* Settings Header */}
      <div>
        <h2 className="text-xl font-semibold">Settings</h2>
        <p className="text-gray-600">Manage your vendor account settings</p>
      </div>

      {/* Business Information */}
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="font-semibold mb-4">Business Information</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Business Name
            </label>
            <input
              type="text"
              value={vendorData?.businessName || ''}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg"
              readOnly
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Contact Email
              </label>
              <input
                type="email"
                value={vendorData?.contactEmail || vendorData?.email || ''}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                readOnly
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Contact Phone
              </label>
              <input
                type="tel"
                value={vendorData?.contactPhone || vendorData?.phone || ''}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                readOnly
              />
            </div>
          </div>
          <button 
            onClick={() => setShowBusinessModal(true)}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700"
          >
            Update Information
          </button>
        </div>
      </div>

      {/* Payment Settings & Flow Documentation */}
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="font-semibold mb-4">Payment Settings</h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between py-2">
            <div>
              <p className="font-medium">Payment Method</p>
              <p className="text-sm text-gray-600">
                {vendorData?.paymentMethod === 'bank_transfer' ? 'Direct Bank Transfer' : 'Check'}
              </p>
            </div>
            <button 
              onClick={() => setShowPaymentMethodModal(true)}
              className="text-blue-600 text-sm hover:underline"
            >
              Change
            </button>
          </div>
          <div className="flex items-center justify-between py-2">
            <div>
              <p className="font-medium">Payout Schedule</p>
              <p className="text-sm text-gray-600">Weekly on Fridays</p>
            </div>
            <button 
              onClick={() => setShowPaymentScheduleModal(true)}
              className="text-blue-600 text-sm hover:underline"
            >
              Change
            </button>
          </div>
        </div>
      </div>

      {/* Payment Flow Documentation */}
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center mb-4">
          <Info className="text-blue-600 mr-2" size={20} />
          <h3 className="font-semibold">How Payments Work</h3>
        </div>
        
        <div className="mb-6">
          <div className="text-center text-lg font-medium text-gray-700 p-4 bg-gray-50 rounded-lg">
            {VENDOR_PAYMENT_FLOW.overview}
          </div>
        </div>
        
        <div className="space-y-4">
          {VENDOR_PAYMENT_FLOW.steps.map((step, index) => (
            <div key={index} className="flex items-start">
              <div className="flex-shrink-0 w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                {step.icon || <span className="font-semibold text-gray-600">{index + 1}</span>}
              </div>
              <div className="ml-4 flex-1">
                <h4 className="font-medium">{step.name}</h4>
                <p className="text-sm text-gray-600 mt-1">{step.description}</p>
                {step.calculation && (
                  <code className="text-xs bg-gray-100 px-2 py-1 rounded mt-2 inline-block font-mono">
                    {step.calculation}
                  </code>
                )}
                {step.timing && (
                  <p className="text-xs text-gray-500 mt-1">
                    <Clock size={12} className="inline mr-1" />
                    {step.timing}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
        
        {/* Example Calculation */}
        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <h4 className="font-medium text-blue-900 mb-3">Example Order Breakdown</h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-700">Order Total:</span>
              <span className="font-medium">${VENDOR_PAYMENT_FLOW.example.orderTotal}</span>
            </div>
            <div className="flex justify-between text-red-600">
              <span>Platform Fee (7.5%):</span>
              <span>-${VENDOR_PAYMENT_FLOW.example.platformFee}</span>
            </div>
            <div className="flex justify-between text-orange-600">
              <span>Logistics Allocation (7.5%):</span>
              <span>-${VENDOR_PAYMENT_FLOW.example.logisticsFee}</span>
            </div>
            <div className="border-t pt-2 flex justify-between font-semibold text-green-600">
              <span>You Receive (85%):</span>
              <span>${VENDOR_PAYMENT_FLOW.example.vendorReceives}</span>
            </div>
          </div>
        </div>
        
        {/* Benefits */}
        <div className="mt-6">
          <h4 className="font-medium mb-3">Why This Model Works</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="flex items-start">
              <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium">For You</p>
                <p className="text-xs text-gray-600">{VENDOR_PAYMENT_FLOW.benefits.vendor}</p>
              </div>
            </div>
            <div className="flex items-start">
              <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium">For Members</p>
                <p className="text-xs text-gray-600">{VENDOR_PAYMENT_FLOW.benefits.members}</p>
              </div>
            </div>
            <div className="flex items-start">
              <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium">For Workers</p>
                <p className="text-xs text-gray-600">{VENDOR_PAYMENT_FLOW.benefits.logistics}</p>
              </div>
            </div>
            <div className="flex items-start">
              <CheckCircle size={16} className="text-green-600 mr-2 mt-0.5 flex-shrink-0" />
              <div>
                <p className="text-sm font-medium">For Platform</p>
                <p className="text-xs text-gray-600">{VENDOR_PAYMENT_FLOW.benefits.platform}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Notification Preferences */}
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="font-semibold mb-4">Notification Preferences</h3>
        <div className="space-y-3">
          <label className="flex items-center justify-between">
            <div>
              <p className="font-medium">Order Notifications</p>
              <p className="text-sm text-gray-600">Get notified when you receive new orders</p>
            </div>
            <input type="checkbox" className="rounded text-blue-600" defaultChecked />
          </label>
          <label className="flex items-center justify-between">
            <div>
              <p className="font-medium">Job Applications</p>
              <p className="text-sm text-gray-600">Get notified when {updateTerminology('members')} apply for your jobs</p>
            </div>
            <input type="checkbox" className="rounded text-blue-600" defaultChecked />
          </label>
          <label className="flex items-center justify-between">
            <div>
              <p className="font-medium">Weekly Reports</p>
              <p className="text-sm text-gray-600">Receive weekly performance summaries</p>
            </div>
            <input type="checkbox" className="rounded text-blue-600" defaultChecked />
          </label>
        </div>
      </div>

      {/* Help & Support */}
      <div className="bg-gray-50 rounded-lg p-6">
        <h3 className="font-semibold mb-3">Need Help?</h3>
        <div className="space-y-2">
          <Link to="/help/vendor-guide" className="block text-blue-600 hover:underline">
            Vendor Help Center
          </Link>
          <Link to="/help/vendor-best-practices" className="block text-blue-600 hover:underline">
            Best Practices Guide
          </Link>
          <Link to="/help/support" className="block text-blue-600 hover:underline">
            Contact Support
          </Link>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
     {/* Header */}
      <div className="bg-white shadow">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold">Vendor Dashboard</h1>
              <p className="text-sm text-gray-600">Welcome back, {vendorData?.businessName}</p>
            </div>
            <div className="flex items-center space-x-3">
              <NotificationBell />
              <div className="relative">
                <button 
                  onClick={() => setShowMessageModal(true)}
                  className="relative p-2 hover:bg-gray-100 rounded-full"
                >
                  <MessageSquare size={20} />
                  {unreadCount > 0 && (
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                      {unreadCount}
                    </span>
                  )}
                </button>
              </div>
              <button 
                onClick={() => setActiveTab('settings')}
                className="p-2 hover:bg-gray-100 rounded-full"
                title="Settings"
              >
                <Settings size={20} />
              </button>
              <button 
                onClick={() => {
                  // Clear vendor auth state
                  vendorLogout();
                  // Clear member auth state AND sign out of Firebase
                  memberLogout();
                  // Navigate to VENDOR login, not welcome screen
                  navigate('/vendor/login');
                }}
                className="px-3 py-1 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>

     {/* Tab Navigation */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="flex space-x-6 overflow-x-auto">
            {[
              { id: 'overview', label: 'Overview', icon: TrendingUp },
              { id: 'products', label: 'Products', icon: Package },
              { id: 'orders', label: 'Orders', icon: ShoppingBag },
              { id: 'jobs', label: 'Jobs', icon: Briefcase },
              { id: 'analytics', label: 'Analytics', icon: BarChart2 },
              { id: 'settings', label: 'Settings', icon: Settings }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 py-4 border-b-2 transition-colors ${
                  tab.id === 'products' ? 'products-tab' : ''
                } ${
                  tab.id === 'orders' ? 'orders-tab' : ''
                } ${
                  tab.id === 'jobs' ? 'jobs-tab' : ''
                } ${
                  tab.id === 'analytics' ? 'analytics-tab' : ''
                } ${
                  activeTab === tab.id
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-600 hover:text-gray-900'
                }`}
              >
                <tab.icon size={18} />
                <span className="font-medium">{tab.label}</span>
              </button>
            ))}
          </div>
        </div>
      </div>

     {/* Content */}
      <div className="container mx-auto px-4 py-6">
        {activeTab === 'overview' && renderOverviewTab()}
        {activeTab === 'products' && renderProductsTab()}
        {activeTab === 'orders' && renderOrdersTab()}
        {activeTab === 'jobs' && renderJobsTab()}
        {activeTab === 'analytics' && renderAnalyticsTab()}
        {activeTab === 'settings' && renderSettingsTab()}
      </div>

     {/* All Modals including NEW Group Analytics Modal */}
      
      {/* NEW: Group Analytics Modal */}
      <GroupAnalyticsModal
        group={selectedGroup}
        isOpen={showGroupAnalyticsModal}
        onClose={() => {
          setShowGroupAnalyticsModal(false);
          setSelectedGroup(null);
        }}
      />

      {/* All existing modals */}
      {showOrderConfirmModal && selectedOrder && (
        <OrderConfirmationModal
          order={selectedOrder}
          onConfirm={confirmOrder}
          onClose={() => {
            setShowOrderConfirmModal(false);
            setSelectedOrder(null);
          }}
        />
      )}

      {showFulfillmentModal && selectedOrder && (
        <FulfillmentModal
          order={selectedOrder}
          onFulfill={fulfillOrder}
          onClose={() => {
            setShowFulfillmentModal(false);
            setSelectedOrder(null);
          }}
        />
      )}

      {showProductDetailsModal && selectedProduct && (
        <EditProductModal
          product={selectedProduct}
          onClose={() => {
            setShowProductDetailsModal(false);
            setSelectedProduct(null);
          }}
          onSuccess={async (updatedProduct) => {
            //await updateProduct(selectedProduct.id, updatedProduct);
            setShowProductDetailsModal(false);
            setSelectedProduct(null);
          }}
          deleteProduct={deleteProduct}  // Pass the delete function
        />
      )}

      {showAddProductModal && (
        <AddProductModal
          isOpen={showAddProductModal}
          onProductAdded={addProduct}
          onClose={() => setShowAddProductModal(false)}
        />
      )}

      {showCSVModal && (
        <CSVUploadHandler
          onUpload={uploadProducts}
          onClose={() => setShowCSVModal(false)}
        />
      )}

      {showOrderDetailsModal && selectedOrder && (
        <OrderDetailsModal
          order={selectedOrder}
          onUpdate={updateOrderStatus}
          onClose={() => {
            setShowOrderDetailsModal(false);
            setSelectedOrder(null);
          }}
        />
      )}

      {showJobModal && (
        <JobPostingForm
          isVendor={true}
          vendorId={vendorData?.id}
          vendorLocation={vendorData?.address}
          onClose={() => setShowJobModal(false)}
          onPost={(jobData) => {
            postVendorJob(jobData);
            setShowJobModal(false);
          }}
        />
      )}

      {showApplicationsModal && selectedJob && (
        <ApplicationsModal
          job={selectedJob}
          applications={selectedJob.applications || []}
          onApprove={approveApplication}
          onReject={rejectApplication}
          onClose={() => {
            setShowApplicationsModal(false);
            setSelectedJob(null);
          }}
        />
      )}

      {showBusinessModal && (
        <BusinessInfoModal
          vendor={vendorData}
          onUpdate={updateBusinessInfo}
          onClose={() => setShowBusinessModal(false)}
        />
      )}

      {showPaymentMethodModal && (
        <PaymentMethodModal
          current={vendorData?.paymentMethod || 'bank_transfer'}
          onUpdate={updatePaymentMethod}
          onClose={() => setShowPaymentMethodModal(false)}
        />
      )}

      {showPaymentScheduleModal && (
        <PaymentScheduleModal
          current={vendorData?.paymentSchedule || 'weekly'}
          onUpdate={updatePaymentSchedule}
          onClose={() => setShowPaymentScheduleModal(false)}
        />
      )}

     {/* Message Modal */}
      {showMessageModal && (
        <MessageModal
          isOpen={showMessageModal}
          onClose={() => {
            setShowMessageModal(false);
            setMessageRecipient(null);
          }}
          recipientId={messageRecipient?.recipientId}
          recipientName={messageRecipient?.recipientName}
          recipientType={messageRecipient?.recipientType}
          orderRef={messageRecipient?.orderRef}
        />
      )}

     {/* Quick Product Modal - placeholder */}
      <Modal
        isOpen={showProductModal}
        onClose={() => setShowProductModal(false)}
        title="Add New Product"
        size="medium"
      >
        <div className="space-y-4">
          <p className="text-gray-600">Quick product creation coming soon!</p>
          <button
            onClick={() => setShowProductModal(false)}
            className="w-full px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
          >
            Close
          </button>
        </div>
      </Modal>

      <BottomNav />
    </div>
  );
};

export default VendorDashboard;
